export default __webpack_public_path__ + "static/media/popcorn-pieces-02.712f264f.png";